export default 
[
  {
    id: -1,
    nome: ''
  },
  {
    id: 0,
    nome: 'Email'
  },
  {
    id: 1,
    nome: 'Celular'
  },
  {
    id: 2,
    nome: 'CPF/CNPJ'
  },
  {
    id: 3,
    nome: 'Chave aleatória'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/tipos-pix.js